import { ClientContactViewModel, ClientContactsDictionary } from '@common/model/client';

export const clientContactsListDataAdaptor = (response: ClientContactViewModel[]): ClientContactsDictionary => {
  return response.reduce<ClientContactsDictionary>((acc, contact) => {
    acc[contact.type] = contact.value;
    return acc;
  }, {});
};
